<!-- Project Start -->
<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">Add new scenario</span>
    <button type="button" aria-label="Close" class="closeModal pull-right" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="scenarioAddEditForm">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="projectName"
              [control]="scenarioAddEditForm.get('projectName')"
              label="Scenario name"
              placeholder="Scenario name"
              [maxLength]="50"
              [submitted]="submitted"
              (customBlur)="onBlur($any(scenarioAddEditForm.get('projectName')?.value))"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="projectNameForReport"
              [control]="scenarioAddEditForm.get('projectNameForReport')"
              label="Scenario name used in report"
              placeholder="Scenario name used in report"
              [maxLength]="15"
              [submitted]="submitted"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group">
            <label
              *ngIf="
                scenarioAddEditForm.get('share')?.value || scenarioAddEditForm.get('status')?.value
              "
              class="sub-header-drpdown pb-2"
              >Select package to copy</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #share
              [items]="packageItems"
              bindLabel="name"
              [searchable]="false"
              formControlName="share"
              [searchFn]="commonInputSearch"
              placeholder="Select scenario"
            >
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group">
            <label
              *ngIf="
                scenarioAddEditForm.get('share')?.value || scenarioAddEditForm.get('status')?.value
              "
              class="sub-header-drpdown pb-2"
              >Status</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #status
              [items]="statusItems"
              [searchable]="false"
              bindLabel="name"
              bindValue="id"
              formControlName="status"
              [searchFn]="commonInputSearch"
              placeholder="Status"
            >
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row my-1">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <piqet-angular-file-upload
            #fileUpload
            type="image"
            [customConfig]="fileUploadConfig"
            [isImageValid]="isImageValid"
            (fileSelected)="onFileSelected($event)"
            (removeConfirmation)="onRemoveConfirmation()"
            [customClass]="'col-sm-12'"
          ></piqet-angular-file-upload>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group">
            <span>
              <p class="description-config d-flex align-items-center">
                Description should be only 600 characters.
              </p>
            </span>
            <div class="services-form">
              <textarea
                formControlName="description"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Description"
                (input)="countCharactersTyped($event)"
              ></textarea>
              <label>Description</label>
            </div>
            <div class="input-error" *ngIf="submitted && isExceeded">
              The length of the description has exceeded the limit
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer d-flex justify-content-start">
    <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
